import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';
import { Box } from '@radix-ui/themes';

import { ActionButton, ButtonGroup } from './StyledComponents';
import Text from '../../shared/Text';
import TextField from '../../shared/TextField';
import useNumberForm from './hooks/usePhoneNumberForm';
import useVerifyPhoneNumber from './hooks/useVerifyPhoneNumber';
import SectionCard from '../../shared/SectionCard/SectionCard.jsx';

export default function ChangeNumber({ verificationNeeded, newPhoneNumber }) {
  const {
    handleChange,
    handleSubmit,
    inputError,
    handleBlur,
    disabledSubmit,
    values,
  } = useNumberForm();
  const {
    handleVerificationCode,
    verifyPhoneNumber,
    verificationCode,
  } = useVerifyPhoneNumber();
  const { t } = useTranslation('accountSettings');

  return (
    <SectionCard title={t('phoneNumberForm.title')}>
      <Box mt="2" pb="4">
        <TextField
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.phoneNumber}
          error={inputError('phoneNumber')}
          name="phoneNumber"
          label={t('phoneNumberForm.numberLabel')}
        />
        {verificationNeeded && (
          <VerificationContainer>
            <TextField
              onChange={handleVerificationCode}
              value={verificationCode}
              name="verificationCode"
              label={t('phoneNumberForm.verificationLabel')}
              warning={t('phoneNumberForm.verificationWarning', {
                newPhoneNumber,
              })}
              placeholder={t('phoneNumberForm.verificationPlaceholder')}
            />
            <VerificationLink onClick={verifyPhoneNumber}>
              <Text variant="small1" color="primary.100">
                {t('phoneNumberForm.verifySubmit')}
              </Text>
            </VerificationLink>
          </VerificationContainer>
        )}
        <Disclosure>
          <Text variant="small2" color="black.80">
            <Trans
              t={t}
              i18nKey="phoneNumberForm.disclosure"
              components={{
                smsTermsLink: (
                  <DisclosureLink
                    href="https://www.airbo.com/sms-terms"
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                ),
                privacyPolicyLink: (
                  <DisclosureLink
                    href="https://www.airbo.com/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                ),
              }}
            />
          </Text>
        </Disclosure>
        <ButtonGroup
          lastInputHasMessage={
            !!inputError('phoneNumber') || verificationNeeded
          }
        >
          <ActionButton
            disabled={disabledSubmit}
            type="submit"
            onClick={handleSubmit}
            variant="containedBlue"
          >
            {t('phoneNumberForm.numberSubmit')}
          </ActionButton>
        </ButtonGroup>
      </Box>
    </SectionCard>
  );
}

const VerificationContainer = styled.div`
  position: relative;
  margin: 24px 0 0;
`;

const VerificationLink = styled.div`
  position: absolute;
  right: 16px;
  bottom: 12px;
  cursor: pointer;
`;

const Disclosure = styled.div`
  margin: 24px 0 0;
`;

const DisclosureLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;
